import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Center, Loader } from "@mantine/core";
import { useAuth } from "./auth/AuthContext.js";
import { AdminRoute } from "./components/AdminRoute.js";
import { CustomerRoute } from "./components/CustomerRoute.js";
import { AdminLayout } from "./pages/admin/AdminLayout.js";
import { AdminLogin } from "./pages/admin/AdminLogin.js";
import { Apps } from "./pages/admin/Apps.js";
import { Assignments } from "./pages/admin/Assignments.js";
import { Customers } from "./pages/admin/Customers.js";
import { IsoAllowlist } from "./pages/admin/IsoAllowlist.js";
import { CustomerLogin } from "./pages/customer/Login.js";
import { CustomerLayout } from "./pages/customer/CustomerLayout.js";
import { Dashboard } from "./pages/customer/Dashboard.js";
import { VmDetail } from "./pages/customer/VmDetail.js";
import { ContainersDashboard } from "./pages/customer/ContainersDashboard.js";
import { ContainerDetail } from "./pages/customer/ContainerDetail.js";
import { AppsDashboard } from "./pages/customer/AppsDashboard.js";
import { AppDeploy } from "./pages/customer/AppDeploy.js";
import { AppInstanceDetail } from "./pages/customer/AppInstanceDetail.js";

function RootRedirect() {
  const auth = useAuth();
  if (auth.status === "loading") {
    return (
      <Center mih="100vh">
        <Loader />
      </Center>
    );
  }
  if (auth.status === "authenticated" && auth.session?.role === "admin") {
    return <Navigate to="/admin" replace />;
  }
  if (auth.status === "authenticated" && auth.session?.role === "customer") {
    return <Navigate to="/dashboard" replace />;
  }
  return <Navigate to="/login" replace />;
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<RootRedirect />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/login" element={<CustomerLogin />} />
        <Route path="/dashboard" element={<CustomerRoute />}>
          <Route element={<CustomerLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="vms/:vmid" element={<VmDetail />} />
            <Route path="containers" element={<ContainersDashboard />} />
            <Route path="containers/:vmid" element={<ContainerDetail />} />
            <Route path="apps" element={<AppsDashboard />} />
            <Route path="apps/catalog/:slug" element={<AppDeploy />} />
            <Route path="apps/instances" element={<AppsDashboard />} />
            <Route path="apps/instances/:id" element={<AppInstanceDetail />} />
          </Route>
        </Route>
        <Route path="/admin" element={<AdminRoute />}>
          <Route element={<AdminLayout />}>
            <Route index element={<Navigate to="customers" replace />} />
            <Route path="customers" element={<Customers />} />
            <Route path="apps" element={<Apps />} />
            <Route path="isos" element={<IsoAllowlist />} />
            <Route path="assignments" element={<Assignments />} />
          </Route>
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
